import {
    ChangeDetectionStrategy,
    Component,
    inject,
    Input,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Index, isDefined } from '@interacta-shared/util';
import { AIContextType, MAIN_THREAD } from '@modules/ai/models/ai.model';
import {
    selectActiveContextType,
    selectActiveHistory,
    selectActiveThread,
} from '@modules/ai/store/ai.selectors';
import { Store } from '@ngrx/store';
import {
    BehaviorSubject,
    distinctUntilChanged,
    filter,
    map,
    Observable,
    switchMap,
} from 'rxjs';

@Component({
    selector: 'interacta-ai-panel',
    templateUrl: './ai-panel.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class AIPanelComponent {
    private store = inject(Store);

    @Input() aiPostAttachmentEnabled = false;

    readonly activeContextType$: Observable<AIContextType>;
    readonly activeThread$: Observable<Index>;

    sideThread$ = new BehaviorSubject<Index | null>(null);
    activeThreadName$ = new BehaviorSubject<string | null>(null);

    readonly AIContextType = AIContextType;
    readonly MAIN_THREAD = MAIN_THREAD;
    readonly ANIMATION_DURATION = 300;

    constructor() {
        this.activeContextType$ = this.store
            .select(selectActiveContextType)
            .pipe(filter(isDefined));

        this.activeThread$ = this.store.select(selectActiveThread);

        this.activeThread$
            .pipe(
                takeUntilDestroyed(),
                distinctUntilChanged(),
                switchMap((value) =>
                    this.store.select(selectActiveHistory(value)).pipe(
                        filter(isDefined),
                        map((result) => ({ value, result })),
                    ),
                ),
            )
            .subscribe(({ value, result }) => {
                if (value !== MAIN_THREAD) {
                    this.sideThread$.next(value);
                }
                this.activeThreadName$.next(result.title);
            });
    }
}
